import React from 'react';

import dialogActions from '../../../hooks/useDialog/dialogActions';

import * as styles from './ModalDialog.module.scss';

interface propsInterface {
    status: dialogActions,
    children: React.ReactNode,
    labelledBy: string,
    describedBy?: string
}

const ModalDialog = ({ labelledBy, describedBy, children, status }: propsInterface): JSX.Element => {
    const animationClassName = status === dialogActions.open ? styles.ModalDialogIn : styles.ModalDialogOut;

    return (
        <div className={`${styles.ModalDialogWrapper} ${animationClassName}`}>
            <dialog
                className={`${styles.ModalDialog}`}
                data-open
                aria-labelledby={labelledBy}
                aria-describedby={describedBy}
                open
            >
                {children}
            </dialog>
        </div>
    );
};

export default ModalDialog;
